import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    innerItemContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative'
    },
    itemName: {
        paddingVertical: 18,
        maxWidth: '85%'
    },
    itemNameWithDescription: {
        paddingTop: 12,
        paddingBottom: 8,
        maxWidth: '85%'
    },
    touchableItemName: {
        marginVertical: 12
    },
    itemDescription: {
        fontFamily: Theme.regularFont,
        fontSize: 17,
        paddingVertical: 0,
        paddingBottom: 10,
        marginLeft: 13
    },
    icon: {
        marginRight: 9,
        width: 25,
        height: 25
    },
    iconDelete: {
        width: 25,
        height: 25,
        justifyContent: 'center',
        right: 24
        // backgroundColor: '#000'
    },
    rightOffset: { marginRight: 12 },
    iconTextContainer: { flexDirection: 'row', alignItems: 'center', paddingRight: 10 }
};

export default StyleSheet.create(baseStyles);
